<template>
  <div class="col-lg-2 col-md-6">
    <span>{{ title }}</span>
    <h4 class="m-t-10">
      <slot />
    </h4>
  </div>
</template>

<script>
export default {
  name: 'AuditHeaderCol',
  props: ['title']
}
</script>
